import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store/store";
import { Provider } from "react-redux";
import { NotificationProvider } from "./context/Notifications";
import { ModalMessageConfirmationProvider } from "context/ModalMessageConfirmation";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/router";
import { StyledEngineProvider } from "@mui/material/styles";
import "./index.css";
import { TranslatorProvider } from "./context/translator";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>

        <StyledEngineProvider injectFirst></StyledEngineProvider>
        <Provider store={store}>
            <TranslatorProvider>
                <ModalMessageConfirmationProvider>
                    <NotificationProvider>

                        <RouterProvider router={router} />

                    </NotificationProvider>
                </ModalMessageConfirmationProvider>
            </TranslatorProvider>
        </Provider>

    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
